import { useEffect, useRef, useState } from 'react';
import RightArrowSVG from '../../assets/hanhwa/icons/right.svg';

type Category = 'sleep' | 'stress' | 'clear';

const CATEGORY_CONFIG = {
  sleep: {
    image: require('../../assets/hanhwa/trackImages/sleep.gif'),
    audio: require('../../assets/hanhwa/sound/sleep.mp3'),
    label: '수면 유도 사운드',
  },
  stress: {
    image: require('../../assets/hanhwa/trackImages/stress.jpg'),
    audio: require('../../assets/hanhwa/sound/stress.mp3'),
    label: '스트레스 완화 사운드',
  },
  clear: {
    image: require('../../assets/hanhwa/trackImages/concentration.jpg'),
    audio: require('../../assets/hanhwa/sound/concentration.mp3'),
    label: '생각 비우기 사운드',
  },
} as const;

export default function VideoPage({ category }: { category: Category }) {
  const [countdown, setCountdown] = useState(5);
  const [hasPlayed, setHasPlayed] = useState(false);
  const [buttonEnabled, setButtonEnabled] = useState(false);
  const [isAutoplayBlocked, setIsAutoplayBlocked] = useState(false);

  const audioRef = useRef<HTMLAudioElement>(null);

  useEffect(() => {
    const playAudio = async () => {
      if (audioRef.current) {
        try {
          audioRef.current.load();
          await audioRef.current.play();
          setHasPlayed(true);
          setIsAutoplayBlocked(false);
        } catch (error) {
          console.error('Autoplay was prevented:', error);
          setIsAutoplayBlocked(true);
        }
      }
    };

    playAudio();
  }, [category]);

  const handleButtonClick = () => {
    if (!hasPlayed) {
      audioRef.current
        ?.play()
        .then(() => {
          setHasPlayed(true);
          setIsAutoplayBlocked(false);
        })
        .catch((e) => console.log('Manual play failed:', e));
      return;
    }

    if (buttonEnabled) {
      window.open('https://forms.gle/qQfGmFqekEyfjRQh8', '_blank');
    }
  };

  useEffect(() => {
    if (!hasPlayed || countdown === 0) return;

    const timer = setInterval(() => {
      setCountdown((prev) => prev - 1);
    }, 1000);

    return () => clearInterval(timer);
  }, [hasPlayed, countdown]);

  useEffect(() => {
    if (countdown === 0) {
      setButtonEnabled(true);
    }
  }, [countdown]);

  return (
    <div className="min-h-screen bg-[#1A1A1A] flex flex-col">
      <div className="flex-1 overflow-y-auto">
        <div className="shrink-0 flex flex-col items-center pt-10 pb-6 w-full px-5">
          <img
            src={require('../../assets/hanhwa/alert.png') || '/placeholder.svg'}
            className="w-[24px] h-[24px] mb-3"
            alt="alert"
          />

          <div className="w-full max-w-md">
            <p className="text-white text-[24px] font-semibold text-center leading-snug mb-6">
              이 사운드는 의학적 근거 기반
              <br />
              {CATEGORY_CONFIG[category].label}입니다.
            </p>

            <a
              href="https://limh6.app.link/hanhwa"
              target="_blank"
              rel="noopener noreferrer"
              className="block w-[90%] mx-auto bg-white/10 rounded-lg p-4 flex items-center justify-between no-underline active:bg-[rgba(255, 255, 255, 0.10)] transition-colors"
            >
              <div className="w-[24px]" />
              <div className="flex-1 text-center">
                <p className="text-[#FFF] text-[16px] leading-[130%]">
                  사운드필 앱을 다운로드하여
                  <br />
                  모든 {CATEGORY_CONFIG[category].label}필을 감상하세요.
                </p>
              </div>
              <div className="w-[24px] flex justify-end">
                <img src={RightArrowSVG || '/placeholder.svg'} alt="arrow" />
              </div>
            </a>
          </div>
        </div>

        <div className="flex justify-center items-center py-6 ">
          <div className="w-full max-w-md">
            <img
              src={CATEGORY_CONFIG[category].image || '/placeholder.svg'}
              alt="category visual"
              className="w-full max-h-[400px] object-cover shadow-2xl"
            />

            <audio ref={audioRef} src={CATEGORY_CONFIG[category].audio} autoPlay playsInline className="hidden" />
          </div>
        </div>
      </div>

      <div className="shrink-0 flex flex-col items-center justify-center pb-8 pt-4 px-6 bg-[#1A1A1A] sticky bottom-0 z-10 shadow-[0_-10px_20px_rgba(26,26,26,0.9)]">
        <button
          onClick={handleButtonClick}
          disabled={hasPlayed && !buttonEnabled}
          className={`w-full max-w-sm h-[60px] rounded-full font-bold text-[16px] transition-all duration-300 shadow-lg flex items-center justify-center ${
            hasPlayed && !buttonEnabled
              ? 'bg-[#4F68FC]/40 text-white/60 cursor-not-allowed'
              : 'bg-[#4F68FC] text-white hover:brightness-110 active:scale-95 cursor-pointer'
          }`}
        >
          {!hasPlayed ? '사운드 재생하고 상품 받기' : buttonEnabled ? '상품받기' : `${countdown}초 후 상품받기`}
        </button>

        {isAutoplayBlocked && !hasPlayed && (
          <p className="text-white/50 text-[12px] mt-3 animate-pulse">위 버튼을 눌러 사운드를 재생해 주세요.</p>
        )}
      </div>
    </div>
  );
}
